import { render } from "./AdditionalNotes.vue?vue&type=template&id=1bdf1b48"
import script from "./AdditionalNotes.vue?vue&type=script&lang=js"
export * from "./AdditionalNotes.vue?vue&type=script&lang=js"

import "./AdditionalNotes.vue?vue&type=style&index=0&id=1bdf1b48&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/AdditionalNotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bdf1b48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bdf1b48', __exports__)) {
    console.log('reload')
    api.reload('1bdf1b48', __exports__)
  }
  
  module.hot.accept("./AdditionalNotes.vue?vue&type=template&id=1bdf1b48", () => {
    console.log('re-render')
    api.rerender('1bdf1b48', render)
  })

}


export default __exports__